export { default } from "./FadeView";
